import { memo } from "react"

import { BackButton } from "../../components/Buttons/BackButton"
import { BaseTopBar } from "../TopBars/BaseTopBar"

export const ProcedureDetailsViewTopBar = memo(() => {
	return <BaseTopBar leftContent={<BackButton />} />
})
ProcedureDetailsViewTopBar.displayName = "ProcedureDetailsViewTopBar"
